<template lang="html">
  <div id="amenities-page">
    <!-- Amenities map image -->
    <div class="amenities-map">
      <div class="map-container">
        <transition name="fade">
          <img src="/static/img/amenity-map.png" v-if="imageReady" />
        </transition>
        <div class="points" :class="{'active': imageReady}">
          <button
            class="point"
            :class="{'active': point.id === activePoint.id}"
            v-for="point in points"
            :key="point.id"
            v-text="point.id"
            :style="{'top': point.y + '%', 'left': point.x + '%'}"
            @click="openRendering(point)"
          />
        </div>
      </div>
    </div>

    <!-- Amenities list -->
    <div class="amenities-list" v-if="imageReady">
      <div class="list-container">
        <div class="title">Ground Floor</div>
        <ul>
          <li
            v-for="point in points"
            :key="point.id"
            @click="openRendering(point)"
          >
            <span class="num" :class="{'active': point.id === activePoint.id}" v-text="point.id"></span>
            <span class="label" v-text="point.name"></span>
            <span class="icon" v-if="point.rendering">
              <i class="material-icons">photo_camera</i>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <!-- Popup -->
    <transition name="fade" mode="out-in">
      <amenities-popup
        v-if="showPopup"
        :point="activePoint"
        @close="showPopup = false"
      />
    </transition>
  </div>
</template>

<script>
import AmenitiesPopup from '@/components/Popup';

export default {
  name: 'amenities-page',
  data() {
    return {
      activePoint: { id: 0 },
      imageReady: false,
      points: [
        { id: 1, name: 'Family Room', rendering: false, x: 7, y: 18 },
        { id: 2, name: 'Media Den', rendering: false, x: 19, y: 51 },
        { id: 3, name: 'Kitchen & Dining', rendering: false, x: 33, y: 14 },
        { id: 4, name: 'Retail', rendering: false, x: 10.5, y: 70 },
        { id: 5, name: 'Reading & Study Library', rendering: false, x: 20, y: 82 },
        { id: 6, name: 'Social Gathering Room', rendering: 'social-gathering-room-full', x: 35, y: 50 },
        { id: 7, name: 'Mail Room', rendering: false, x: 56, y: 59 },
        { id: 8, name: 'Main Lobby', rendering: 'lobby-full', x: 48, y: 25 },
        { id: 9, name: 'Elevator Lobby', rendering: false, x: 70, y: 50 },
        { id: 10, name: 'Parcel Storage', rendering: false, x: 56.5, y: 33 },
        { id: 11, name: 'Dog & Bike Wash', rendering: false, x: 58.5, y: 12 },
        { id: 12, name: 'Fitness Centre', rendering: false, x: 80, y: 70 }
      ],
      showPopup: false
    };
  },
  methods: {
    openRendering(point) {
      this.activePoint = point;
      if (point.rendering) {
        this.showPopup = true;
      }
      return false;
    }
  },
  created() {
    const img = new Image();
    img.onload = () => {
      this.imageReady = true;
    };
    img.src = '/static/img/amenity-map.png';
  },
  components: {
    'amenities-popup': AmenitiesPopup
  }
};
</script>

<style lang="scss">
#amenities-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #bceffa;

  .amenities-map {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    width: 75vw;
    @media (max-width: 1100px) {
      width: 70vw;
    }

    .map-container {
      position: relative;
      img {
        max-width: 90%;
      }

      .points {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        transition: opacity 0.25s ease-out;
        &.active { opacity: 1; }

        .point {
          font-family: 'FuturaLTW01-Bold';
          font-size: 1rem;
          position: absolute;
          background-color: #fecb3e;
          border-radius: 50%;
          cursor: pointer;
          border: none;
          padding: 0;
          height: 2rem;
          width: 2rem;
          line-height: 2rem;
          text-align: center;
          -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
          -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);
          box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.5);

          &.active { background-color: #bceffa; }
        }
      }
    }
  }

  .amenities-list {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    width: 25vw;
    text-align: left;
    background-color: white;
    @media (max-width: 1100px) {
      width: 30vw;
    }

    .title {
      font-family: 'FuturaLTW01-Bold';
      font-size: 1.75rem;
      @media (max-width: 1024px) {
        padding-left: 1.25rem;
        font-size: 1.25rem;
      }
    }

    ul {
      list-style-type: none;
      margin: 1.25rem 0;
      padding: 1.5rem 1.25rem;
      border-top: 5px solid black;
      border-bottom: 5px solid black;

      li {
        padding: 0.5rem 0;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        &:active {
          .label {
            color: #299cb5;
          }
        }

        span.num {
          display: inline-block;
          font-family: 'FuturaLTW01-Bold';
          font-size: 1rem;
          background-color: #fecb3e;
          border-radius: 50%;
          cursor: pointer;
          border: none;
          height: 2rem;
          width: 2rem;
          padding: 0;
          line-height: 2rem;
          text-align: center;
          margin-right: 1.25rem;
          &.active { background-color: #bceffa; }
        }

        span.icon {
          display: inline-block;
          vertical-align: middle;
          margin-left: 0.5rem;
          i.material-icons {
            font-size: 18px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AmenitiesPage/AmenitiesPage.vue